import axios from "axios";
import { toast } from "react-toastify";
import { API_ERROR_500 } from "../../../../../config";
import { setLoading, getStageScreen } from "../../../../../redux";
import {
  GET_VISUAL_REQUEST,
  GET_VISUAL_SUCCESS,
  GET_VISUAL_FAILURE,
} from "./type";
import { getApiHeader, getApiUrl } from "utils";

export const handleVisualVerify = (data, callback) => {
  const API_URL = getApiUrl();
  const headers = getApiHeader();
  return async (dispatch) => {
    dispatch({ type: GET_VISUAL_REQUEST });
    dispatch(setLoading(true));
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.upload_visual_verification`,
        data,
        headers
      );
      console.log("resp", resp);
      dispatch({ type: GET_VISUAL_SUCCESS });
      // dispatch(getStageScreen());
      dispatch(setLoading(false));
      toast.success(resp?.data?.message);
      callback(resp?.data);
    } catch (error) {
      const { response } = error || {};
      console.log("err", response);
      toast.error(response?.data?.message || API_ERROR_500);
      dispatch({
        type: GET_VISUAL_FAILURE,
        payload: response?.data?.message || "something went wrong",
      });
      dispatch(setLoading(false));
    }
  };
};

export const onSubmitVisualVerify = () => {
  const API_URL = getApiUrl();
  const headers = getApiHeader();
  return async (dispatch) => {
    dispatch({ type: GET_VISUAL_REQUEST });
    dispatch(setLoading(true));
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.confirm_visual_verification`,
        {},
        headers
      );
      dispatch({ type: GET_VISUAL_SUCCESS });
      dispatch(getStageScreen());
      dispatch(setLoading(false));
      toast.success(resp?.data?.message);
    } catch (error) {
      const { response } = error || {};
      console.log("err", response);
      toast.error(response?.data?.message || API_ERROR_500);
      dispatch({
        type: GET_VISUAL_FAILURE,
        payload: response?.data?.message || "something went wrong",
      });
      dispatch(setLoading(false));
    }
  };
};
